import { __awaiter } from "tslib";
import path from 'path';
const { createJiti } = require('jiti');
const DEFAULT_CONFIG_PATH = 'module-federation.config.ts';
export const getConfigPath = (userConfigPath) => {
    const defaultPath = path.resolve(process.cwd(), DEFAULT_CONFIG_PATH);
    const filepath = userConfigPath !== null && userConfigPath !== void 0 ? userConfigPath : defaultPath;
    return path.isAbsolute(filepath)
        ? filepath
        : path.resolve(process.cwd(), filepath);
};
export function readConfig(userConfigPath) {
    return __awaiter(this, void 0, void 0, function* () {
        const configPath = getConfigPath(userConfigPath);
        const jit = createJiti(__filename, {
            interopDefault: true,
            esmResolve: true,
        });
        const configModule = yield jit(configPath);
        const resolvedConfig = (configModule &&
            typeof configModule === 'object' &&
            'default' in configModule
            ? configModule.default
            : configModule);
        return resolvedConfig;
    });
}
